import React from 'react'

export default function LoadingModal() {
	return (
		<div className='modalOverlay'>
			<h1 className='text-white text-xl'>Loading...</h1>
		</div>
	)
}
